exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".close-btn {\n  position: absolute;\n  top: 0;\n  right: 10px;\n  z-index: 100; }\n\nh5 {\n  color: #000;\n  font-size: 20px;\n  margin-top: -5px; }\n\n.errors {\n  font-family: 'Roboto', sans-serif;\n  color: #E55049; }\n\nmd-dialog-content {\n  font-family: 'Roboto', sans-serif; }\n\n.vertical-center {\n  margin-top: -18px; }\n\n.precio-especial span {\n  position: absolute;\n  color: #A2A2A2; }\n\n.precio-especial input {\n  text-align: right; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/negocios/negocios/precio-especial-dialog.component.scss
// module id = ../../../../../src/app/components/negocios/negocios/precio-especial-dialog.component.scss
// module chunks = 0